import {useEffect, useState, useRef} from "react";
// -
import WsConnector from "core/wsConnector";
import apiAxi from "ApiCaller";

const CheckWS = () => {
    const wsConn = new WsConnector();
    const messages = useRef([]);
    const [messagesShow, setMessagesShow] = useState([]);
    const [messageOut, setMessageOut] = useState("");

    wsConn.message = (e) => {
        console.log("[wsConn].message");
        let data = JSON.parse(e.data);

        messages.current.push(data);
        setMessagesShow([...messages.current]);
    };

    const messageSend = (e) => {
        setMessageOut(e.target.value);
    };

    const onClickSend = () => {
        apiAxi.post("/api/checker/ws/", {message: messageOut}).then((resp) => {
            console.log(resp);
        });
    };
    const activeWebsocket = () => {
        console.log("[CheckWS].activeWebsocket()");
        wsConn.setUrl("/ws/checker/");
        wsConn.connect();
    };

    useEffect(() => {
        activeWebsocket();
        return () => {
            wsConn.close();
        };
    }, []);

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-6">
                    <h2>Enviar</h2>
                    <textarea className="form-control" value={messageOut} onChange={messageSend} rows={5} />
                    <div className="text-end">
                        <button className="btn btn-primary" onClick={onClickSend}>
                            Enviar
                        </button>
                    </div>
                </div>
                <div className="col-6">
                    <div className="col-12">
                        <h2>Recibido</h2>
                        <div className="col-12">
                            <ul className="list-unstyled">
                                {messagesShow ? (
                                    messagesShow.map((item, key) => <li key={key}>{JSON.stringify(item)}</li>)
                                ) : (
                                    <></>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CheckWS;
